import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../../language/vn';
import {FormBuilder} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {environment} from '../../../../../environments/environment';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {CommandUtil} from '../../../../global/commandutil';
import {SelectFolderComponent} from '../../folder/select.component';
import {DoMatService} from '../../../../service/danhmuc/service-domat';
import {LoaiVanBanService} from '../../../../service/danhmuc/service-loaivanban';
import {DoMat} from '../../../../models/danhmuc/domat';
import {LoaiVanBan} from '../../../../models/danhmuc/loaivanban';
import {GroupOTherComponent} from '../../groupother/groupother.component';
import {HoSoLuuTruService} from '../../../../service/hoso/service-hosoluutru';
import {HoSoLuuTru} from '../../../../models/hoso/hosoluutru';
import {DatePipe} from '@angular/common';
import {EditHoSoLuuTruComponent} from './edit.component';

@Component({
  templateUrl: './luutru.component.html'
})
export class HoSoLuuTruComponent implements OnInit, AfterViewInit {

  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public totalItems: number = 0;
  public hoSoId:  number;
  public slGroupSearch: string = 'slGroupSearch';
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public dataList: HoSoLuuTru[];
  public doMatList: DoMat[] = [];
  public loaiVanBanList: LoaiVanBan[] = [];
  public srNguoiKy: string = '';
  public srTrichYeu: string = '';
  public srFromDate: Date;
  public srToDate: Date ;
  public srDoMatId: number= -1;
  public srLoaiVanBanId: number = -1;
  public strF: string = '';
  public strT: string = '';
  @ViewChild("selectGroup")
  public selectGroup: GroupOTherComponent ;
  public srTuKhoa: string = '';
  constructor( public hosoLuuTruService: HoSoLuuTruService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public commandUtil: CommandUtil,
               public doMatService: DoMatService,
               public loaiVanBanService: LoaiVanBanService,
               public datePipe: DatePipe

  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.doMatService.getAll().subscribe(data => this.doMatList = data);
    this.loaiVanBanService.getAll().subscribe( data => this.loaiVanBanList = data);
    this.search();

  }
  public showConfirmationModal(id: number): void {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_delete_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.deleteItem(id);
      }
    });
  }
  edit(id: number) {
    const modalEdit = this.bsModalService.show(EditHoSoLuuTruComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<EditHoSoLuuTruComponent>modalEdit.content).edit(
      id
    );
    (<EditHoSoLuuTruComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.search();
      }
    });
  }
  selectSave(id: number) {
    const modalEdit = this.bsModalService.show(SelectFolderComponent);
    (<SelectFolderComponent>modalEdit.content).edit(
      id
    );
    (<SelectFolderComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {

      }
    });
  }
  public search()
  {
    this.strF = this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy');
    this.strT =  this.datePipe.transform(this.srToDate, 'MM/dd/yyyy');
    let coQuanId: number = this.selectGroup != null && Number(this.selectGroup.selectTree.value)!=0? Number(this.selectGroup.selectTree.value): -1;
    this.hosoLuuTruService.findAllByPaging(coQuanId,
                                          this.srDoMatId,
                                          this.srLoaiVanBanId,
                                          this.srNguoiKy,
                                          this.srTuKhoa,
                                          this.srTrichYeu,
                                          this.strF,
                                          this.strT,
                                          Sessioncommand.staffId, this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.hosoLuuTruService.getCountByKeyword(coQuanId,
      this.srDoMatId,
      this.srLoaiVanBanId,
      this.srNguoiKy,
      this.srTuKhoa,
      this.srTrichYeu,
      this.strF,
      this.strT, Sessioncommand.staffId).subscribe(recordCount => this.totalItems = recordCount);
  }


  deleteItem(id: number)
  {
    this.hosoLuuTruService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search();


      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }

  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}
